module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          return _vm.sortBy(key)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm._f("capitalize")(key)) + "\n                  "), _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
    })])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.selectOrg(entry)
        }
      }
    }, [_vm._v("Select")])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51a66e6b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserOrganizationsTable.vue
// module id = 626
// module chunks = 1